import NetworkState from '../../../core/types/network';
import { ReduxAction, DispatchFunc } from '../../../core/types/redux';
import { RequestInfo } from '../result/types';
import { FormInfo } from '../resultDetails/types';

export enum ResultPreviewActionConstants {
  INITIALIZE = '@@resultPreview/INITIALIZE',
  RESULT_PREVIEW_REQUEST = '@@resultPreview/RESULT_PREVIEW_REQUEST',
  RESULT_PREVIEW_SET = '@@resultPreview/RESULT_PREVIEW_SET',
  ATTACH_PREVIEW_REQUEST = '@@resultPreview/ATTACH_PREVIEW_REQUEST',
  ATTACH_PREVIEW_SET = '@@resultPreview/ATTACH_PREVIEW_SET',
}

export interface RequestResultPreviewArgs {
  form: FormInfo;
  requestInfo?: RequestInfo;
  resultIds?: string[];
}

export interface SetResultPreviewArgs {
  result?: any;
  error?: Error;
}

export interface RequestAttachPreviewArgs {
  requestInfo?: RequestInfo;
  attachmentId: string;
  filePath: string;
  fileType: string;
}

export interface SetAttachPreviewArgs {
  result?: any;
  error?: Error;
}

export type ResultPreviewAction<TArgs> = ReduxAction<TArgs, ResultPreviewActionConstants>;
export type ResultPreviewDispatchFunc<TArgs> = DispatchFunc<TArgs, ResultPreviewActionConstants>;

export interface ResultPreviewState {
  networkStates: {
    resultPreviewRequest: NetworkState;
    attachPreviewRequest: NetworkState;
  };
  isPreviewInitialized: boolean;
  loadedStatus?: any;
}
